export const UPDATE_CRITERIA_TAB = 'UPDATE_CRITERIA_TAB';
export const UPDATE_STUDENT_GRID = 'UPDATE_STUDENT_GRID'
export const UPDATE_ACTIVITY_TAB = 'UPDATE_ACTIVITY_TAB'
export const UPDATE_DISABLED_TABS = 'UPDATE_DISABLED_TABS'
